const { isPlatformSuperAdmin, isTenantProjectManager } = require('./roomAccessUi.cjs')
const { PRODUCTION_SKILLS, isProductionWorker, canUseProduction } = require('./productionAccess.cjs')
function skillPublished(skill) {
  return Boolean(skill && skill.status === 'live')
}
function canUseSkill(user, skill) {
  if (!user || !user.token || !skillPublished(skill)) return false
  if (PRODUCTION_SKILLS.has(skill.id)) return canUseProduction(user)
  if (isProductionWorker(user)) return false
  return skill.id === 'iot-system-design'
    ? isTenantProjectManager(user) || isPlatformSuperAdmin(user)
    : isPlatformSuperAdmin(user)
}
function skillLabel(user, skill) {
  if (!skillPublished(skill)) return '即将上线'
  if (!user || !user.token) return '请先登录'
  return canUseSkill(user, skill) ? '可使用' : '无权限'
}
module.exports = { skillPublished, canUseSkill, skillLabel }
